(function () {
  // captured at first parse — before the async DOMContentLoaded wait — so this always points
  // to the <script> tag's own position, even when re-injected (e.g. into a quick-add modal
  // alongside another instance of this same form/script)
  const scriptEl = document.currentScript;

  function init() {
    // main-product.liquid has two alternate buy_buttons layouts (only one renders per page);
    // this script is only ever included inside the one that carries the multi-discount UI, and
    // [data-sus-product-form] (also used by main-product.js) is that layout's own product-form marker
    const scope = scriptEl.closest('[data-sus-product-form]') || document;

    const mdInput = scope.querySelector('.quantity__input_multidiscount');
    const mdQtyWrapper = scope.querySelector('.sus_md-quantity-container');
    const mdSavingDisplay = scope.querySelector('.sus_md-quantity-container [data-js-saving-total]');
    const mdHidden = scope.querySelector('[data-js-multi-discount]');
    const priceRawEl = scope.querySelector('[data-sus-md-price-raw]');
    if (!mdHidden || !mdInput || !priceRawEl) return; // exit if setup is missing or incomplete
    const mdHiddenGroup = mdHidden.getAttribute('data-js-multi-discount');
    const radios = scope.querySelectorAll('input[name="sus_qty"]');

    // money formatter derived from known price pair
    const unitPriceRaw = parseInt(priceRawEl.getAttribute('data-sus-md-price-raw'));
    const unitPriceFormatted = priceRawEl.getAttribute('data-sus-md-price-formatted');

    // detect decimal separator from rendered price
    const decimalSeparator = unitPriceFormatted.includes(',') ? ',' : '.';

    function formatMoney(cents) {
      const newAmount = (cents / 100).toFixed(2).replace('.', decimalSeparator);
      const knownAmount = (unitPriceRaw / 100).toFixed(2).replace('.', decimalSeparator);
      return unitPriceFormatted.replace(knownAmount, newAmount);
    }

    function getApplicableTier(qty) {
      let matched = null;
      radios.forEach((radio) => {
        const tierQty = parseInt(radio.value);
        if (tierQty <= qty && tierQty > 1) {
          if (!matched || tierQty > parseInt(matched.value)) {
            matched = radio;
          }
        }
      });
      return matched;
    }

    function calcSaving(qty, percent) {
      const savingPerItem = Math.floor(unitPriceRaw * percent / 100);
      return formatMoney(savingPerItem * qty);
    }

    function updateByQty(qty) {
      qty = parseInt(qty);

      // sync radios — check matching, uncheck others
      let matchedRadio = null;
      radios.forEach((radio) => {
        if (parseInt(radio.value) === qty) {
          radio.checked = true;
          matchedRadio = radio;
        } else {
          radio.checked = false;
        }
      });

      // no exact match — activate highest applicable tier
      if (!matchedRadio) {
        const applicableTier = getApplicableTier(qty);
        if (applicableTier) {
          applicableTier.checked = true;
          matchedRadio = applicableTier;
        }
      }

      if (qty > 1) {
        mdQtyWrapper.classList.remove('hidden');
        if (matchedRadio) {
          const percent = parseInt(matchedRadio.getAttribute('data-js-susmd-percent'));
          mdSavingDisplay.textContent = calcSaving(qty, percent);
        } else {
          mdSavingDisplay.textContent = '';
        }
      } else {
        mdQtyWrapper.classList.add('hidden');
        mdSavingDisplay.textContent = '';
        // mdHidden.value = '';
      }

      // update dicountID
      var mdId = scope.querySelector('input[name="id"]').value;
      mdHidden.value = mdHiddenGroup + '-' + mdId;
    }

    // radio clicked → update input then trigger shared update
    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        mdInput.value = radio.value;
        const qtyInput = mdInput.closest('quantity-input');
        if (qtyInput) qtyInput.setMinimumDisable();
        updateByQty(radio.value);
        mdInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // input changed → sync radios and saving display
    mdInput.addEventListener('change', () => {
      updateByQty(mdInput.value);
    });

    // update discount on variant change
    document.addEventListener('sus:variant:changed', (e) => {
      // if (mdHidden && mdHidden.value !== '') {
      if (mdHidden) {
        mdHidden.value = mdHiddenGroup + '-' + e.detail.variantId;
      }
    });
  }

  // DOMContentLoaded has already fired by the time this script re-executes after being
  // injected into a modal — init directly rather than waiting on an event that already happened
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
